import { defineStore } from 'pinia'
import { ref, watch } from 'vue'

import Insurance from '@/modules/common/common/models/APP/Insurance'
import { useSharedGtmDataStore } from './sharedGtmDataStore'

export const useBusinessStore = defineStore('businessStore', () => {
  const businessLine = ref<string>('')
  const hiringNumber = ref<string>('')
  const businessLineName = ref<string>('')
  const insurance = ref<Insurance | null>(null)
  const logo = ref<string>('icon-logo')
  const sharedGtmDataStore = useSharedGtmDataStore()

  // Watch for changes in businessLine and businessLineName
  watch(
    businessLine,
    () => {
      sharedGtmDataStore.reset()
    },
    { immediate: true }
  )

  function setBusinessLine(value: string): void {
    businessLine.value = value
  }
  function getBusinessLine(): string {
    return businessLine.value
  }
  function setBusinessLineName(value: string): void {
    businessLineName.value = value
  }
  function getBusinessLineName(): string {
    return businessLineName.value
  }
  function setHiringNumber(value: string): void {
    hiringNumber.value = value
  }
  function getHiringNumber(): string {
    return hiringNumber.value
  }
  function setInsurance(value: Insurance | null): void {
    insurance.value = value
  }
  function getInsurance(): Insurance | null {
    return insurance.value
  }

  return {
    logo,
    setBusinessLine,
    getBusinessLine,
    setBusinessLineName,
    getBusinessLineName,
    setHiringNumber,
    getHiringNumber,
    setInsurance,
    getInsurance
  }
})
